import React from 'react';
import { Link } from 'react-router-dom';


function NavLink({ to, children, ...props }) {
  if (to.indexOf('http') === 0) {
    var navlink = (<a href={to} {...props}>{children}</a>);
  } else {
    var navlink =(<Link to={to} {...props}>{children}</Link>);
  }
  return (navlink);
}


export default  NavLink;



// WEBPACK FOOTER //
// ./src/components/layouts/NavLink.js